import { render } from "./viewDriveDocumentComponent.vue?vue&type=template&id=29e84e00"
import script from "./viewDriveDocumentComponent.vue?vue&type=script&lang=js"
export * from "./viewDriveDocumentComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__